import { Injectable } from '@angular/core';
import {Restangular} from 'ngx-restangular';
import {BehaviorSubject} from 'rxjs';

interface MemberInfo {
    member: {
        spouse: boolean;
        otherDependents: number;
        beneficiaries: number;
    };
    product: {
        beneficiariesSupported: boolean;
    };
}

@Injectable({
    providedIn: 'root'
})

export class UsersInsuranceService {

    public usersInsuranceObservable = new BehaviorSubject(null);

    constructor(
        private restangular: Restangular,
    ) { }

    // PRIMARY

    getInsurancePrimary(userId: string, vendorId: string): Promise<any> {
        return this.restangular.one('users/insurance/primary', userId).one(vendorId).get().toPromise();
    }

    createInsurancePrimary(userId: string, vendorId: string, gender: string, metadata: any, tobaccoUseDate: string): Promise<any> {
        return this.restangular.one('users/insurance/primary', userId).one(vendorId).customPOST({
            gender,
            metadata,
            tobaccoUseDate,
        }).toPromise();
    }

    modifyInsurancePrimary(userId: string, vendorId: string, fields: any): Promise<any> {
        return this.restangular.one('users/insurance/primary', userId).one(vendorId).customPUT({
            ...fields
        }).toPromise();
    }

    deleteInsurancePrimary(userId: string, vendorId: string): Promise<any> {
        return this.restangular.one('users/insurance/primary', userId).one(vendorId).remove().toPromise();
    }

    // DEPENDENTS

    getInsuranceDependents(userId: string, vendorId: string): Promise<any> {
        return this.restangular.one('users/insurance/dependent', userId).one(vendorId).getList().toPromise();
    }

    createInsuranceDependent(userId: string, vendorId: string, gender: string, metadata: any, tobaccoUseDate: string, firstName: string, lastName: string, dob: string, relationship: string, ssn: string, email: string, phone: string): Promise<any> {
        return this.restangular.one('users/insurance/dependent', userId).one(vendorId).customPOST({
            gender,
            metadata,
            tobaccoUseDate,
            firstName,
            lastName,
            dob,
            relationship,
            ssn,
            email,
            phone
        }).toPromise();
    }

    modifyInsuranceDependent(userId: string, dependentId: string, fields: any): Promise<any> {
        return this.restangular.one('users/insurance/dependent', userId).one(dependentId).customPUT({
            ...fields
        }).toPromise();
    }

    deleteInsuranceDependent(userId: string, dependentId: string): Promise<any> {
        return this.restangular.one('users/insurance/dependent', userId).one(dependentId).remove().toPromise();
    }

    // BENEFICIARIES

    getInsuranceBeneficiaries(userId: string, vendorId: string): Promise<any> {
        return this.restangular.one('users/insurance/beneficiary', userId).one(vendorId).getList().toPromise();
    }

    createInsuranceBeneficiary(
        userId: string,
        vendorId: string,
        firstName: string,
        lastName: string,
        ssn: string,
        relationship: string,
        beneficiaryType: string,
        percentage: string,
        dob: string,
        email: string,
        phone: string,
        address1: string,
        address2: string,
        city: string,
        state: string,
        postalcode: string
        ): Promise<any> {
        return this.restangular.one('users/insurance/beneficiary', userId).one(vendorId).customPOST({
            beneficiaryType,
            percentage,
            relationship,
            firstName,
            lastName,
            ssn,
            dob,
            email,
            phone,
            address1,
            address2,
            city,
            state,
            postalcode
        }).toPromise();
    }

    modifyInsuranceBeneficiary(userId: string, beneficiaryId: string, fields: any): Promise<any> {
        return this.restangular.one('users/insurance/beneficiary', userId).one(beneficiaryId).customPUT({
            ...fields
        }).toPromise();
    }

    deleteInsuranceBeneficiary(userId: string, beneficiaryId: string): Promise<any> {
        return this.restangular.one('users/insurance/beneficiary', userId).one(beneficiaryId).remove().toPromise();
    }

    getInsuranceStateForUser(userId): Promise<any> {
        return this.restangular.one('users/insurance', 'all').one('user', userId).getList().toPromise();
    }

    getInsuranceProductsForUser(userId): Promise<any> {
        return this.restangular.one('users/insurance', 'products').one('user', userId).get().toPromise();
    }

    getMemberInfoForProduct(vendorProductId: string): Promise<MemberInfo> {
        return this.restangular.one('users/insurance', 'memberinfo').one('vendorproduct', vendorProductId).get().toPromise();
    }

    // CARRIER UPDATES

    updateCarriers(userId): Promise<any> {
        return this.restangular.one('users/insurance/carrier/update', userId).put().toPromise();
    }

 }
